import type { TVisibilityAppSource } from '../../../types/tracking'
import { dateTimeAgo } from '../../../utils/datetime-utils'
import { StatusIcon } from '../status-icon'

interface IVisibilityAppTooltip {
  trackingSourceData: TVisibilityAppSource
}

/**
 * The component that displays the Visibility app info and its tooltip
 */
export const VisibilityAppTooltip = (props: IVisibilityAppTooltip) => {
  const { trackingSourceData } = props
  const trackingSourceMetadata = trackingSourceData?.metadata

  return (
    <div className="p-4">
      <div className="flex w-full flex-col space-y-2 items-start">
        <span className="text-foreground text-md font-semibold">
          {trackingSourceMetadata?.provider || 'Visibility Provider'}
        </span>

        {!!trackingSourceMetadata?.deviceID && (
          <span className="max-w-96 text-sm text-muted-foreground">Device ID: {trackingSourceMetadata.deviceID}</span>
        )}

        {!!trackingSourceData?.locations?.length && (
          <span className="text-foreground text-sm">
            Last seen: {dateTimeAgo(trackingSourceData.locations[trackingSourceData.locations.length - 1]?.timestamp)}
          </span>
        )}

        <div className="flex items-center space-x-2">
          <StatusIcon isPositive={Boolean(trackingSourceData.locations?.length)} />
          <span className="text-sm">Status: {trackingSourceData?.locations?.length ? 'Tracking' : 'Not tracking'}</span>
        </div>
      </div>
    </div>
  )
}

VisibilityAppTooltip.displayName = 'VisibilityAppTooltip'
